export default __webpack_public_path__ + "static/media/plants.ac8c37b5.svg";